import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Features } from "@/components/site/Features";
import { Testimonials } from "@/components/site/Testimonials";
import { DownloadFooter } from "@/components/site/DownloadFooter";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-ink">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Features />
      <Testimonials />
      <DownloadFooter />
    </main>
  );
}
